import { t } from '../../i18n/t';
import { setUI, useGame, useUI, type Panel } from '../../state/store';
import { Btn, useFmt } from '../common';

export function TopBar() {
  const souls = useGame((g) => g.meta.souls);
  const consumed = useGame((g) => g.meta.lifetime.consumed);
  const hasRun = useGame((g) => !!g.run);
  const pages = useGame((g) => g.meta.lifetime.ledgerPages.length);
  const teeth = useGame((g) => g.meta.teeth);
  const molts = useGame((g) => g.meta.molts);
  const shown = useUI((u) => u.displayedSouls);
  const panel = useUI((u) => u.panel);
  const screen = useUI((u) => u.screen);
  const fmt = useFmt();
  const toggle = (p: Panel) => setUI({ panel: panel === p ? null : p });
  return (
    <div className="topbar interactive">
      <span data-anchor="souls" style={{ color: '#a884f3' }}>
        ◈ {t('ui.souls')} {fmt(shown ?? souls)}
      </span>
      <span className="dim">☠ {t('ui.consumedCount', { n: consumed })}</span>
      {teeth > 0 || molts > 0 ? (
        <span className="kw-value">
          {t('ui.teeth')} {teeth}
        </span>
      ) : null}
      <span style={{ flex: 1 }} />
      {screen === 'machine' && hasRun && (
        <>
          <Btn kind="ghost" onClick={() => toggle('deck')} testId="btn-deck">
            {t('ui.deck')}
          </Btn>
          <Btn kind="ghost" onClick={() => toggle('odds')}>
            ? {t('ui.odds')}
          </Btn>
        </>
      )}
      {pages > 0 && (
        <Btn kind="ghost" onClick={() => toggle('ledger')}>
          {t('ui.ledger.title')}
        </Btn>
      )}
      <Btn kind="ghost" onClick={() => toggle('codex')} testId="btn-codex">
        {t('ui.codex.button')}
      </Btn>
      <Btn kind="ghost" onClick={() => toggle('settings')}>
        ⚙
      </Btn>
    </div>
  );
}
